export const FRIENDLY_MESSAGES = {
  default: 'Sorry, something is wrong!',
  overconstrainederror:
    'Oops, looks like your microphone or camera you selected is being used by another application!',
};
